
module.exports = {
  createHealthHistory(timeFrame) {
    const healthHistory = [];
    let startDay;
    const interval = timeFrame * 60000;
    let start = new Date(Math.floor(new Date().getTime() / interval) * interval);
    switch (timeFrame) {
      case 120:
        startDay = 7;
        break;
      case 60:
        startDay = 3;
        break;
      case 15:
        startDay = 1;
        break;
      default:
        startDay = 7;
    }
    start.setDate(start.getDate() - startDay);
    const current = new Date();
    while (start < current) {
      healthHistory.push({
        env: 'sdk',
        avg: 1,
        servertype: '',
        time_bucket: start,
      });
      start = new Date(start.getTime() + interval);
    }
    return healthHistory;
  },
};
